import { FunctionResultOptions } from "./function-result-options.class.mjs";
export class FunctionResult {
  // #region Properties (4)
  data;
  length;
  options;
  status;
  // #endregion Properties (4)
  // #region Constructors (1)
  constructor(status, data, length, options) {
    this.status = status;
    this.data = data;
    this.length = length;
    if (options === undefined) {
      this.options = new FunctionResultOptions();
    } else {
      this.options = options;
    }
  }
}